import React from 'react';
import { momentParseDate } from '../../../helpers';

interface Props {
    purchaseDocument: any;
}

const PurchaseDocumentCondition = ({ purchaseDocument }: Props) => {
    return (
        <div className="purchase-document-condition">
            <div className="row">
                {/* Row for Payment Method */}
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label htmlFor="paymentMethod">Método de pago:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={purchaseDocument?.payment_method || ''}
                            disabled
                        />
                    </div>
                </div>
                
                {/* Spacer column to align the next row underneath */}
                <div className="col-md-6"></div>

                {/* Row for Payment Condition and Due Date */}
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label htmlFor="paymentCondition">Condición de pago:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={purchaseDocument?.payment_condition || ''}
                            disabled
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label htmlFor="dueDate">Fecha de vencimiento:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={momentParseDate(purchaseDocument?.due_date || '')}

                            disabled
                        />
                    </div>
                </div>
            </div>
                          {/* Fechas de Cambio */}
            <div className="row mb-3">
                <div className="col-md-6">
                <div className="form-group mb-3">
                    <label htmlFor="final_exchange_rate_date">
                    Fecha Cambio Final:
                    </label>
                    <input
                    type="text"
                    id="final_exchange_rate_date"
                    className="form-control"
                    value={momentParseDate(purchaseDocument?.final_exchange_rate_date)}
                    disabled
                    />
                </div>
                </div>

                <div className="col-md-6">
                <div className="form-group mb-3">
                    <label htmlFor="final_exchange_rate_date">
                    Valor Cambio Final:
                    </label>
                    <input
                    type="text"
                    id="final_rate"
                    className="form-control"
                    value={(purchaseDocument?.final_rate)}
                    disabled
                    />
                </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseDocumentCondition;
